import React, {useEffect, useState} from "react";
import "./MainBlog.scss";
import TopBlogComponent from "./TopBlogComponent";
import axios from "axios";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import Title from "../Title/Title";
import {prefixUrl} from "../../Utils/utilsData";
import Loader from "../Loader/Loader";

const MainBlog = () => {

  const [dataFetched, setDataFetched] = useState(false);
  const [backendData, setBackendData] = useState("");
  const [text, setText] = useState("");
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    if (!dataFetched) {
      axios
        .get(`${prefixUrl()}/blog/get.php`)
        .then((res) => {
          if (res.data.status) {
            setBackendData(res.data.output);
            setText(res.data.output.footerText);
            setDataFetched(true);
            setIsLoad(true)
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [dataFetched]);

  // Split the backend data into two arrays
  const firstFourItems = backendData?.data?.slice(0, 4) || [];
  const nextFourItems = backendData?.data?.slice(4, 8) || [];
  let textFoot = text && text.replace(/\n/g, "<br>");

  return (
    <>
      {isLoad ?
        <div className="main-blog-page main-blog-container">
          <Title title={"بلاگ"} englishTitle={"Blog"}/>
          <TopBlogComponent
            firstFourItems={firstFourItems}
            nextFourItems={nextFourItems}
          />
          {/* <TopBlogComponent nextFourItems={nextFourItems} blogData={blogData} /> */}
          {/* <BlogListTitle /> */}
          {/* -----// for Pagination need Data From Back //---- */}
          <div className="view_all_blogs">
            <Link to={"/allBlogs"} className="view_all_blogs_btn">
              مشاهده همه
            </Link>
          </div>
          <div className="tz-bottom">
            <h6 dangerouslySetInnerHTML={{__html: textFoot}}/>
            {/* {textFoot} */}
          </div>
        </div> : <Loader/>
      }</>
  );
};
export default MainBlog;
